import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';
import { flexbox, flex, alignItems, flexDirection, justifyContent } from '../../styles/helpers/flexbox';

const CourseFilterWrapper = styled.div((props) => {
    const { typography } = ThemeHelper.getTheme(props);

    return `
    ${flexbox()}
    font-family: ${typography.family};`;
});

const FilterTabs = styled.div((props) => {
    const { palette, typography } = ThemeHelper.getTheme(props);

    return `
    ${flexbox()}
    ${flex('20%')}
    ${alignItems('flex-end')}
    font-family: ${typography.family};

    & > a {
        color: ${palette.primary.main};
        text-decoration: none;
        padding: 0 10px;
        min-width: 100px;
        height: 55px;
        line-height: 55px;
        text-align: center;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border: 1px solid ${palette.primary.light};
        cursor: pointer;

        &[aria-current="true"] {
            background-color: ${palette.primary.main};
            color: #fff;
            pointer-events: none;
        }
    }`;
});

/* eslint-disable arrow-body-style */
const FilterItems = styled.div(() => {
    return `
    ${flexbox()}
    ${flex('80%')}
    ${flexDirection('row')}
    ${alignItems('center')}
    ${justifyContent('flex-end')}

    & > div {
        margin: 10px 0 10px 10px;
    }`;
});

export { CourseFilterWrapper, FilterTabs, FilterItems };



// WEBPACK FOOTER //
// ./app/components/course-filter/styled.js